module.exports = __webpack_public_path__ + "static/img/badge.f162df91.png";